import React, { Children } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem('user')
            ? <Component {...props}/>
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
);

PrivateRoute.propTypes = {
    component: PropTypes.any,
    location: PropTypes.any
};